// chakra imports
import { Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
// Assets
import { LogOut } from "lucide-react";
import { useAuth } from "lib/auth";
import { userController } from "lib/user";

function SidebarFooter() {
  const { logout } = useAuth();
  const { userDetail } = userController();
  const { getUser } = userDetail();

  const textColor = useColorModeValue("navy.700", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const iconColor = useColorModeValue("gray.700", "white");

  return (
    <Flex
      align="center"
      justify="space-between"
      borderTop="1px solid"
      borderColor={borderColor}
      px="20px"
      py="16px">
      <Text fontSize="sm" fontWeight="700" color={textColor} noOfLines={1}>
        {getUser?.name}
      </Text>
      <Icon
        as={LogOut}
        w="20px"
        h="20px"
        color={iconColor}
        cursor="pointer"
        _hover={{ color: "brand.500" }}
        onClick={logout}
      />
    </Flex>
  );
}

export default SidebarFooter;
